import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {CmsConfig, I18nModule, provideConfig} from "@spartacus/core";
import {GonvarriQuoteItemsComponent} from "../../components/gonvarri-quote-items/gonvarri-quote-items.component";
import {
  GonvarriQuoteSummaryActionsComponent
} from "../../components/gonvarri-quote-summary-actions/gonvarri-quote-summary-actions.component";
import {GonvarriQuoteSummaryComponent} from "../../components/gonvarri-quote-summary/gonvarri-quote-summary.component";
import {QuoteSummaryPricesModule} from "@spartacus/quote/components";
import {DatePickerModule, IconModule} from "@spartacus/storefront";
import {GonvarriCartSharedModule} from "../gonvarri-cart-shared-module/gonvarri-cart-shared-module.module";
import {gonvarriOccQuoteConfig} from "../../occ/gonvarri-occ-quote-config";
import { GonvarriQuoteRequestButtonComponent } from 'src/app/components/gonvarri-quote-request-button/gonvarri-quote-request-button.component';
import { GonvarriQuoteSummarySellerEditComponent } from '../../components/gonvarri-quote-summary-seller-edit/gonvarri-quote-summary-seller-edit.component';
import {ReactiveFormsModule} from "@angular/forms";
import { GonvarriQuoteSummaryPricesComponent } from '../../components/gonvarri-quote-summary-prices/gonvarri-quote-summary-prices.component';

@NgModule({
  declarations: [
    GonvarriQuoteItemsComponent,
    GonvarriQuoteSummaryActionsComponent,
    GonvarriQuoteSummaryComponent,
    GonvarriQuoteRequestButtonComponent,
    GonvarriQuoteSummarySellerEditComponent,
    GonvarriQuoteSummaryPricesComponent,
  ],
  imports: [
    CommonModule,
    I18nModule,
    IconModule,
    GonvarriCartSharedModule,
    DatePickerModule,
    ReactiveFormsModule
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        QuoteItemsComponent: {
          component: GonvarriQuoteItemsComponent
        },
        QuoteSummaryActionsComponent: {
          component: GonvarriQuoteSummaryActionsComponent
        },
        QuoteSummaryComponent: {
          component: GonvarriQuoteSummaryComponent
        },
        QuoteRequestComponent: {
          component: GonvarriQuoteRequestButtonComponent,
        },
      }
    }),
    provideConfig(gonvarriOccQuoteConfig),
  ]
})
export class GonvarriQuotesModule { }
